export default "__VITE_ASSET__CyMhwAGX__"